import { render, staticRenderFns } from "./PriorityAdd.vue?vue&type=template&id=61a1d289&"
import script from "./PriorityAdd.vue?vue&type=script&lang=js&"
export * from "./PriorityAdd.vue?vue&type=script&lang=js&"
import style0 from "./PriorityAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports